import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";

import CabinetLeg from "../subparts/cabinet/cabinetLeg";
import Countertop from "../subparts/cabinet/countertop";
import Hook from "../subparts/cabinet/hook";
import CabinetGroup from "../subparts/cabinet/cabinetGroup";
import Slatwall from "../subparts/cabinet/slatwall";
import OverheadRack from "../subparts/cabinet/overheadRack";
import BottomCabinet from "../subparts/cabinet/bottomCabinet";
import TopCabinet from "../subparts/cabinet/topCabinet";
import TallCabinet from "../subparts/cabinet/tallCabinet";
import TallHandle from "../subparts/cabinet/tallHandle";
import TallCabinetLeg from "../subparts/cabinet/tallCabinetLeg";
import TopHandle from "../subparts/cabinet/topHandle";
import BottomHandle from "../subparts/cabinet/bottomHandle";
import BottomCabinetLeg from "../subparts/cabinet/bottomCabinetLeg";

export default class Cabinet extends Part {
  static id = 'Cabinet';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Cabinet';
    this.partThumbnail = "";
    this.translateId = "visualizer.kitchen.cabinet";

    // related items
    this.worktop = null;
    this.cabinetLeg = null;
    this.hook = null;
    this.slatWall = null;
    this.tallCabinet = null;
    this.tallHandle = null;
    this.tallCabinetLeg = null;
    this.relatedGroupNames = ["Countertop", "Bottom Handle", "Top Handle", "Bottom Cabinet", "Top Cabinet",
      "Bottom Cabinet Leg", "Tall Cabinet", "Tall Cabinet Leg", "Tall Handle"];
  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Worktop":
      case "Countertop":
        relatedItemName = "countertop";
        RelatedItemClass = Countertop;
        break;
      case "Cabinet Leg":
        relatedItemName = "cabinetLeg";
        RelatedItemClass = CabinetLeg;
        break;
      case "Bottom Cabinet Leg":
        relatedItemName = "bottomCabinetLeg";
        RelatedItemClass = BottomCabinetLeg;
        break;
      case "Cabinet":
        relatedItemName = "cabinetGroup";
        RelatedItemClass = CabinetGroup;
        break;
      case "Hook":
      case "Double Hook":
      case "Kayak Hook":
      case "Single Hook":
      case "Vertical Bike Hook":
        relatedItemName = "hook";
        RelatedItemClass = Hook;
        break;
      case "Slatwall":
      case "Slat Wall":
        relatedItemName = "slatWall";
        RelatedItemClass = Slatwall;
        break;
      case "Overhead Rack":
        relatedItemName = "Overhead Rack";
        RelatedItemClass = OverheadRack;
        break;
      case "Bottom Cabinet":
        relatedItemName = "bottomCabinet";
        RelatedItemClass = BottomCabinet;
        break;
      case "Top Cabinet":
        relatedItemName = "topCabinet";
        RelatedItemClass = TopCabinet;
        break;
      case "Tall Cabinet":
        relatedItemName = "tallCabinet";
        RelatedItemClass = TallCabinet;
        break;
      case "Tall Handle":
      case "Tall Cabinet Handle":
        relatedItemName = "tallHandle";
        RelatedItemClass = TallHandle;
        break;
      case "Tall Cabinet Leg":
        relatedItemName = "tallCabinetLeg";
        RelatedItemClass = TallCabinetLeg;
        break;
      case "Top Handle":
        relatedItemName = "topHandle";
        RelatedItemClass = TopHandle;
        break;
      case "Bottom Handle":
        relatedItemName = "bottomHandle";
        RelatedItemClass = BottomHandle;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        if (relatedItemName !== "shadows") {
          this.relatedItems.push(this[relatedItemName]);
        }
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Cabinet', this);
  }

}
